module.exports = __webpack_public_path__ + "static/img/bidder_tit_icon.728369bc.png";